<p-menubar class="show-on-desktop" [model]="menu"></p-menubar>
<p-panelMenu class="show-on-mobile" [model]="menu"></p-panelMenu>

